export default __webpack_public_path__ + "static/media/role.60fe0d5a.png";